import { StandingAPIService } from "./standing";
import api from "..";

export default new StandingAPIService(api);
